<div class="dialog-container">
  <h2 class="dialog-title">{{ isEdit ? 'Rename Template' : 'Create Template' }}</h2>

  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="template-name-group">
      <label class="input-label">Template Name</label>
      <input type="text" formControlName="name" class="input-text"
             placeholder="Enter template name">
      @if (form.get('name')?.touched && (form.get('name')?.hasError('required') || form.get('name')?.hasError('whitespace'))) {
        <div class="error-message">Name is required</div>
      }
      @if (form.get('name')?.touched && form.get('name')?.hasError('minlength')) {
        <div class="error-message">Name must be at least 2 characters</div>
      }
    </div>

    <div class="dialog-actions">
      <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button type="submit" class="save-btn" [disabled]="form.invalid">
        {{ isEdit ? 'Rename' : 'Create' }}
      </button>
    </div>
  </form>
</div>
